import { lazy, PureComponent, Suspense } from 'react';

import Helmet from 'react-helmet'
import { type RouteComponentProps } from 'react-router'

const CatalogChunk = lazy(() =>
  import('../containers/Catalog').then(({ Catalog }) => ({
    default: Catalog,
  }))
)

export class CatalogPage extends PureComponent<RouteComponentProps> {
  render() {
    return (
      <div>
        <Helmet>
          <title>Procurify | Catalog</title>
        </Helmet>
        <Suspense fallback={null}>
          <CatalogChunk />
        </Suspense>
      </div>
    );
  }
}
